import React, { useState } from 'react';
import Header from "../../components/Header/Header";
import GiftsList from "../../components/GiftsList/GiftsList";
import GiftsHeader from "../../components/PagesHeaders/GiftsHeader/GiftsHeader";
import GiftForm from "../../components/GiftForm/GiftForm";
import GiftsOrders from "../GiftsOrders/GiftsOrders";


const Gifts = () => {
    // Текущая страница
    const [ordersPage, setOrdersPage] = useState(true);

    return (
        <>
            <Header component={ <GiftsHeader page={ ordersPage } setPage={ setOrdersPage } /> }/>
            <GiftForm />
            <div className="page">
                { ordersPage && <GiftsOrders/> }
                { !ordersPage && <GiftsList/> }
            </div>
        </>
    );
};

export default Gifts;